import { useContext } from "react";
import { Typography } from "@mui/material";
import { AlternateAliasContext } from "../../context/AlternateAliasContext";
import { useAlternateAliasInfo } from "./useAlternateAliasInfo";

const SECTIONS = [
    {
        heading: "Identity",
        fields: [
            { label: "DN", key: "DN" },
            { label: "User Principal Name", key: "UPN" },
            { label: "Display Name", key: "Display Name" },
            { label: "Description", key: "Description" },
        ],
    },
    {
        heading: "Organization",
        fields: [
            { label: "Department", key: "Department" },
            { label: "Manager", key: "Manager" },
        ],
    },
    {
        heading: "Mail",
        fields: [
            { label: "Mail Alias", key: "Mail Alias" },
            { label: "Email", key: "Email" },
            { label: "Target Address", key: "Target Address" },
        ],
    },
];

const renderCell = (value) =>
    value ? (
        <Typography variant="body2">{value}</Typography>
    ) : (
        <Typography variant="body2" color="text.disabled" fontStyle="italic">—</Typography>
    );

// Returns one "tile" per section (Identity / Organization / Mail), each
// carrying the length of its longest value so the grid can size it.
export const useAlternateAliasSections = () => {
    const { isLoaded, error } = useAlternateAliasInfo();
    const { aliasModule } = useContext(AlternateAliasContext);

    if (!isLoaded || error) {
        return { isLoaded, error, tiles: [] };
    }

    const data = aliasModule.data || {};

    const tiles = SECTIONS.map((section) => {
        const rows = section.fields.map(({ label, key }) => {
            const value = data[key];
            return { key, label, content: renderCell(value), length: value ? String(value).length : 0 };
        });
        return {
            key: section.heading,
            heading: section.heading,
            rows,
            maxLength: rows.reduce((max, row) => Math.max(max, row.length), 0),
        };
    });

    return { isLoaded, error, tiles };
};
